
const lists = state => state.lists;
const data = state => param => state.data[param];
const listdata = state => param => state.lists[param];
const tagdata = state => state.tagdata;
const show = state=>state.data.show
const dataobject = state => state.data;


export default {
    lists,
    data,
    show,
    tagdata,
    listdata,
    dataobject
};